import { useState } from "react";
import { searchUsers } from "../services/campaignMeta.api";

export default function UserMultiSelect({ onChange }) {

  const [search, setSearch] = useState("");
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState([]);

  async function handleSearch(value) {
    setSearch(value);

    if (value.length < 2) return;

    const res = await searchUsers(value);
    setUsers(res.data);
  }

  function toggleUser(userId) {
    let updated;

    if (selected.includes(userId)) {
      updated = selected.filter(id => id !== userId);
    } else {
      updated = [...selected, userId];
    }

    setSelected(updated);
    onChange(updated);
  }

  return (
    <div>
      <input
        placeholder="Search users..."
        value={search}
        onChange={(e) => handleSearch(e.target.value)}
      />

      <div style={{ maxHeight: 150, overflowY: "auto" }}>
        {users.map(user => (
          <div key={user.userId}>
            <label>
              <input
                type="checkbox"
                checked={selected.includes(user.userId)}
                onChange={() => toggleUser(user.userId)}
              />
              {user.firstName}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
}
